import { createInitials } from 'global/common/dataAdjust';
import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useMatchCompare } from 'projectSpecific/sports/useHelpers/useMatchCompare';
import { useContext, useEffect, useState } from 'react';
import { Label } from 'semantic-ui-react';
import { TeamOpps } from '../teams/TeamOpps';

const MatchGrid = ({ levelKey, selectedTeam }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches_groupInfo } = matches_info ?? {};
  const { matches_combined: matches } = matches_groupInfo ?? {};

  const [selectedTeam_column, setSelectedTeam_column] = useState([])
  const [selectedTeam_row, setSelectedTeam_row] = useState()
  const [selectedOppTeams, setSelectedOppTeams] = useState([])
  const [selectedOppTeamsWithMatches, setSelectedOppTeamsWithMatches] = useState([])

  useEffect(() => {
    handleSelectedTeam_row(selectedTeam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeam]);

  const sss = useMatchCompare({ matches, teams })

  const currentTeams = !_.isEmpty(selectedOppTeams) ? _.sortBy(selectedOppTeams, 'name') : _.sortBy(teams, 'name')

  const sameSection = (team_row_key, team_column_key) => {
    return (teams?.[team_row_key]?.levels === teams?.[team_column_key]?.levels) &&
      (teams?.[team_row_key]?.sections === teams?.[team_column_key]?.sections)
  }

  const handleSelectedTeam_row = (team) => {

    setSelectedTeam_column()
    setSelectedOppTeams([])

    if (!team) {
      setSelectedTeam_row()
      return;
    }
    const oppKeys = sss.getOpponentKeys({ teamKey: team?._itemKey })
    oppKeys.push(team._itemKey)
    const oppTeams = sss.getOpponentTeams({ opponentKeys: oppKeys })
    const _oppTeamWithMatches = sss.getFilteredOpponentsWithMatches({ teamKey: team?._itemKey, excludeSectionMatches: false })
    setSelectedOppTeamsWithMatches(_oppTeamWithMatches)
    setSelectedOppTeams(oppTeams)
    setSelectedTeam_row(team)
  }

  const handleSelectedTeam_column = (team) => {
    if (!team) {
      setSelectedTeam_column()
      return;
    }
    setSelectedTeam_column(selectedTeam_column?._itemKey === team?._itemKey ? null : team)
  }

  const getPairKey = (a, b) => {
    return _.sortBy([a, b]).join('_');
  };

  // Group matches by normalized pair
  const matchMap = _.reduce(matches, (acc, m) => {
    const home = _.get(m, 'home.id');
    const away = _.get(m, 'away.id');

    if (home && away) {
      const key = getPairKey(home, away);

      if (!acc[key]) acc[key] = [];
      acc[key].push(m);
    }

    return acc;
  }, {});

  const getMatchDisplay = (team_row_key, team_column_key) => {
    const key = getPairKey(team_row_key, team_column_key);
    const matches = _.get(matchMap, key, []);

    // get the oppMatches from the selectedTeam_column
    const _oppMatches = selectedOppTeamsWithMatches?.[selectedTeam_column?._itemKey]?.[team_row_key]

    if (!_.isEmpty(matches)) {
      // loop the matches for the row_column
      const mls = _.map(matches, (match, mk) => {
        // get the props for the match
        const { _results, startDate, _itemKey, teams: teams_match } = match ?? {}
        const { winner, loser, scoreDisplays } = _results ?? {}
        const { normal, full } = scoreDisplays ?? {}

        let color = 'black';
        let cn = ''
        const oppMatch = _oppMatches ? _.find(_oppMatches, { _itemKey: _itemKey }) : null
        if (oppMatch) {
          cn = ' mco'
        }
        if (winner) {
          if (winner?._itemKey === team_row_key || winner?.id === team_row_key) {
            color = 'green'
          } else if (loser?._itemKey === team_row_key || loser?.id === team_row_key) {
            color = 'red'
          }
          return <Label size='mini' color={color} title={full} className={cn}>{normal}</Label>
        } else {
          const sd = startDate
          const _sd = sd.split('/')
          const md = `${_sd[0]}/${_sd[1]}`
          return <Label size='mini' color={color} title={full} className={cn}>{md}</Label>
        }
      })
      return mls
    } else {
      return <div></div>
    }
  }

  return (
    <div className='match-grid-wrapper'>
      <div className='match-grid-container'>
        {/* Header Row */}
        <div className='mgc-row'>
          <div className={'mgc-cell hdr ept'} onClick={() => { handleSelectedTeam_row() }}>{'x'}</div>
          {_.map(currentTeams, team => {
            const _colSelected = selectedTeam_column?._itemKey === team?._itemKey
            return <div key={team._itemKey} className={`mgc-cell hdr ${_colSelected ? 'col-sel' : ''}`} title={team.name} onClick={() => { handleSelectedTeam_column(team) }}>
              {createInitials(team.name, 3)}
            </div>
          })}
        </div>

        {/* Body */}
        {_.map(currentTeams, rowTeam => (
          <div key={rowTeam._itemKey} className={`mgc-row ${selectedTeam_row?._itemKey === rowTeam?._itemKey ? 'sel' : ''} `}>
            {/* Row Header */}
            <div className='mgc-cell hdr' title={rowTeam.name} onClick={() => { handleSelectedTeam_row(rowTeam) }}>
              {createInitials(rowTeam.name, 3)}
            </div>

            {/* Cells */}
            {_.map(currentTeams, colTeam => {
              const isSame = rowTeam._itemKey === colTeam._itemKey;
              const _sameSection = !isSame && sameSection(rowTeam._itemKey, colTeam._itemKey)
              const _colSelected = selectedTeam_column?._itemKey === colTeam?._itemKey
              return (
                <div key={colTeam._itemKey} className={`mgc-cell ${_sameSection ? 'sec-match' : ''} ${_colSelected ? 'col-sel' : ''}`}>
                  {isSame
                    ? ''
                    : getMatchDisplay(rowTeam._itemKey, colTeam._itemKey)
                  }
                </div>
              );
            })}

          </div>
        ))}
      </div>
      <div className='match-opp-container'>
        <TeamOpps team={selectedTeam_row} oppTeam={selectedTeam_column} noMid={true} />
      </div>
    </div>
  );
};

export default MatchGrid;